<template>
  <b-modal
    id="notifications"
    modal-class="modal-panel"
    dialog-class="modal-panel-dialog"
    content-class="modal-panel-content flex flex-col"
    header-class="modal-panel-header"
    body-class="modal-panel-body flex flex-col flex-auto overflow-y-auto"
    footer-class="modal-panel-footer"
    :hide-header-close="true"
    :hide-footer="true">
    <template v-slot:modal-title>
      <div class="flex flex-row items-center justify-between">
        <span class="modal-title">Уведомления</span>
        <span
          class="text-primary cursor-pointer"
          @click="readAll">Прочитать все</span>
      </div>
    </template>
    <template v-slot:default>
      <div class="flex flex-col flex-shrink-0 space-y-10 p-8">
        <NotificationsDay
          :day="day"
          v-for="(day, dayIndex) in payload"
          :key="dayIndex"/>
        <infinite-loading
          @infinite="onInfiniteLoading">
          <div slot="spinner"></div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
          <div slot="error"></div>
        </infinite-loading>
      </div>
    </template>
    <template v-slot:modal-footer>
      <div></div>
    </template>
  </b-modal>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import NotificationsDay from '@/components/Notifications/Core/NotificationsDay.vue';

export default {
  components: {
    InfiniteLoading,
    NotificationsDay,
  },
  computed: {
    ...mapState({
      notifications: (state) => state.notifications.data,
      completed: (state) => state.notifications.completed,
    }),
    payload() {
      const data = _.groupBy(
        this.notifications,
        (obj) => moment(obj.createdAt).format('DD MMMM YYYY'),
      );
      return _(data)
        .keys()
        .reduce((acc, value) => {
          acc.push({
            date: value,
            payload: data[value],
          });
          return acc;
        }, []);
    },
  },
  methods: {
    ...mapActions({
      fetch: 'notifications/ACT_FETCH_NOTIFICATIONS',
      read: 'notifications/ACT_READ_NOTIFICATION',
    }),
    onInfiniteLoading($state) {
      if (!this.completed) {
        this.fetch().then((completed) => {
          if (completed) {
            $state.complete();
          } else {
            $state.loaded();
          }
        }).catch(() => {
          $state.error();
        });
      }
    },
    readAll() {
      this.read(null);
    },
  },
};
</script>
